import React from 'react';

import Styles from './Loader.module.scss';

const Loader = () => {
  return (
    <div className={Styles.loader}>
      <svg viewBox="25 25 50 50">
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    </div>
  );
};

export default Loader;
